import { gql } from 'urql';

export const mutationRemoveNode = gql`
  mutation RemoveNode($nodeId: String!) {
    removeNode(nodeId: $nodeId)
  }
`;
